import { IconButton } from "@/components/common";
import { RequireOnlyOne } from "@/interfaces/common";
import { To } from "react-router-dom";
import { BaseTableActionProps } from "..";

type Props = Readonly<
  BaseTableActionProps & {
    to?: To;
  }
>;

export const TableEdit = (props: RequireOnlyOne<Props, "onClick" | "to">) => {
  return <IconButton {...props} icon="Pencil" aria-label="Editar" />;
};
